@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.action-button {
  padding-right: 0;
  margin-left: 10px;
}

.unassigned-option {
  display: flex;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  text-align: left;
  padding: 10px;
  border: none;
  border-bottom: 1px solid @grid-header--default--border-color;
  font-size: 14px;
  color: @grid-header--assign-button--text-color;
  background: @grid-header--assign-button--background-color;
  cursor: pointer;

  &:hover {
    background: @grid-header--assign-button--hover--background-color;
    text-decoration: none;
  }

  .icon-wrap {
    height: 30px;
    width: 30px;
    background-color: @grid-header--assign-button--icon--background-color;
    border-radius: 50%;
    margin-right: 10px;
    svg {
      height: 30px;
      width: 30px;
      color: @grid-header--assign-button--icon--fill-color;
      transform: scale(0.55);
    }
  }
}
